module.exports = __webpack_public_path__ + "img/heart_structureFunction.c0d0104a.png";